var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 13.0501L6.7501 18.3001C6.6001 18.4501 6.4251 18.5251 6.2251 18.5251C6.0251 18.5251 5.8501 18.4501 5.7001 18.3001C5.5501 18.1501 5.4751 17.9751 5.4751 17.7751C5.4751 17.5751 5.5501 17.4001 5.7001 17.2501L10.9501 12.0001L5.7001 6.7501C5.5501 6.6001 5.4751 6.4251 5.4751 6.2251C5.4751 6.0251 5.5501 5.8501 5.7001 5.7001C5.8501 5.5501 6.0251 5.4751 6.2251 5.4751C6.4251 5.4751 6.6001 5.5501 6.7501 5.7001L12.0001 10.9501L17.2501 5.7001C17.4001 5.5501 17.5751 5.4751 17.7751 5.4751C17.9751 5.4751 18.1501 5.5501 18.3001 5.7001C18.4501 5.8501 18.5251 6.0251 18.5251 6.2251C18.5251 6.4251 18.4501 6.6001 18.3001 6.7501L13.0501 12.0001L18.3001 17.2501C18.4501 17.4001 18.5251 17.5751 18.5251 17.7751C18.5251 17.9751 18.4501 18.1501 18.3001 18.3001C18.1501 18.4501 17.9751 18.5251 17.7751 18.5251C17.5751 18.5251 17.4001 18.4501 17.2501 18.3001L12.0001 13.0501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ceda71d7.svg";
export { ForwardRef as ReactComponent };